import { techTheme } from 'src/features/common/app/components/theme-provider/theme';
import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { Typography } from 'src/ui/common/atoms/typography';
import { Checkbox } from 'src/ui/white-labels/techcontemporary/atoms/checkbox/checkbox';
import { TextInput } from 'src/ui/white-labels/techcontemporary/atoms/text-input';
import styled from 'styled-components';

export const StyledCheckedItem = styled(FlexBox)<{ checked: boolean }>`
    cursor: pointer;
    padding: 10px 16px;
    ${({ checked, theme }) =>
        checked &&
        `
            background: ${theme.colors.grey800};
            border-radius: 48px;
        `}
    margin-bottom: 8px;
`;

export const StyledCurrency = styled(Typography)`
    position: absolute;
    right: 20px;
    top: 50%;
    margin-top: -8px;
`;

export const PriceRangeWrapper = styled(FlexBox)`
    margin-bottom: 10px;
`;

export const StyledCheckBox = styled(Checkbox)`
    margin-left: 0 !important;
`;

export const StyledInputWrapper = styled(FlexBox)`
    display: flex;
`;

export const StyledTextInput = styled(TextInput)`
    width: 70% !important;
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;

    &:focus {
        box-shadow: none;
        border-left: 1px solid rgba(255, 255, 255, 0.06);
        border-top: 1px solid rgba(255, 255, 255, 0.06);
        border-bottom: 1px solid rgba(255, 255, 255, 0.06);
        border-right: none;
        color: white;
    }

    &:hover {
        box-shadow: none;
        border-left: 1px solid rgba(255, 255, 255, 0.06);
        border-top: 1px solid rgba(255, 255, 255, 0.06);
        border-bottom: 1px solid rgba(255, 255, 255, 0.06);
        border-right: none;
    }
`;

export const StyledSection = styled.div`
    border-left: 1px solid rgba(255, 255, 255, 0.06);
    min-width: 40px;
    padding: 8px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${techTheme.colors.grey800};
`;